import { Modal } from 'medere-ui-framework'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { StockItemTypeContractListItemDTO } from '../../../dto/stockItemTypeContract/StockItemTypeContractDTO'
import { formatIsoDate, formatPercentage } from '../stockItemTypeContractFormat'

interface OverlappingContractsModalProps {
  visible: boolean
  contracts: StockItemTypeContractListItemDTO[]
  onClose: () => void
}

export default function OverlappingContractsModal({
  visible,
  contracts,
  onClose,
}: Readonly<OverlappingContractsModalProps>) {
  return (
    <Modal
      visible={visible}
      setVisible={(nextVisible) => {
        if (!nextVisible) onClose()
      }}
      header={<span className='stc-modal-title'>Contratos existentes</span>}
      width='w-xlarge'
      className='stc-modal'
      footerButtonLeftText='Cerrar'
      onClickLeftBtn={onClose}
    >
      <DataTable
        value={contracts}
        dataKey='stockitemtypecontract'
        size='small'
        scrollable
        scrollHeight='20rem'
        className='stc-conflicts-table'
        emptyMessage='No hay contratos para mostrar.'
      >
        <Column field='healthentityname' header='Obra social' />
        <Column field='healthentityplanname' header='Plan' />
        <Column field='stockitemtypedesc' header='Tipo de ítem' />
        <Column field='contractattentionmodalitydesc' header='Modalidad' />
        <Column
          header='Cobertura'
          bodyClassName='text-right'
          body={(contract: StockItemTypeContractListItemDTO) => formatPercentage(contract.percentage)}
        />
        <Column
          header='Válido desde'
          align='center'
          body={(contract: StockItemTypeContractListItemDTO) => formatIsoDate(contract.validfrom)}
        />
        <Column
          header='Válido hasta'
          align='center'
          body={(contract: StockItemTypeContractListItemDTO) => (
            contract.validuntil ? formatIsoDate(contract.validuntil) : 'Sin fecha de fin'
          )}
        />
      </DataTable>
    </Modal>
  )
}
